<template>
  <base-modal
    name="basic-modal"
    :visible="show"
    close-button
    close-outside
    @close="closeModal"
  >
    <div class="flex flex-col">
      <h3 class="text-7 font-bold leading-6 text-color-1 mb-7">
        {{ isUpdate ? $t('ApiKey | update') : $t('ApiKey | new') }}
      </h3>

      <base-input
        v-model="formData.name"
        :label="$t('ApiKey | name')"
        :placeholder="$t('ApiKey | namePlaceholder')"
      />

      <base-button class="mt-10" :disabled="!formData.name" @onClick="onSubmit">
        <base-loader v-if="loading" :stroke-width="3" />

        <div v-else>
          {{
            isUpdate ? $t('ApiKey | buttonUpdate') : $t('ApiKey | buttonCreate')
          }}
        </div>
      </base-button>
    </div>
  </base-modal>
</template>

<script setup>
import { reactive, computed, watch } from 'vue'
import { useStore } from 'vuex'

import BaseInput from '@emcd-shared/base-input'
import BaseModal from '@emcd-shared/base-modal'
import BaseLoader from '@/packages/BaseLoader/Spinner/Spinner.vue'
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'

import { API_KEY_DISPATCHERS, API_KEY_GETTERS } from '@/shared/constants'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  isUpdate: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update:modelValue', 'onSubmit'])

const store = useStore()

const formData = reactive({
  name: '',
  api_key: '',
  api_secret: '',
})

const show = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits('update:modelValue', value)
  },
})

const formDataStore = computed(() => store.getters[API_KEY_GETTERS.formData])

const loading = computed(() => store.getters[API_KEY_GETTERS.actionLoading])

async function onSubmit() {
  if (loading.value) return

  if (props.isUpdate) {
    const { success } = await store.dispatch(API_KEY_DISPATCHERS.updateApiKey, {
      ...formData,
      created_at: new Date(),
    })

    if (success) {
      emits('onSubmit')
    }
    return
  }

  const { success } = await store.dispatch(API_KEY_DISPATCHERS.createApiKey, {
    ...formData,
    created_at: new Date(),
  })

  if (success) {
    emits('onSubmit')
  }
}

function parseData() {
  if (props.isUpdate) {
    Object.keys(formData).forEach((key) => {
      formData[key] = formDataStore.value[key]
    })
  }
}

function closeModal() {
  show.value = false
}

function clearData() {
  Object.keys(formData).forEach((key) => {
    formData[key] = null
  })
}

watch(show, (value) => {
  if (value) {
    parseData()
  } else {
    clearData()
  }
})
</script>
